import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  showIcon = true,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      window.open('https://www.thealphamethods.com/cart/44502834249814:1', '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-gradient-to-r from-gold to-gold-accent
        text-dark font-bold text-base md:text-lg
        py-3 px-6 rounded-full shadow-lg
        hover:shadow-xl transition-all duration-300
        flex items-center justify-center gap-3
        w-full md:w-auto mx-auto
        ${className}
      `} {...props} data-id="element-29">
      <span className="relative z-10" data-id="element-30">{children}</span>
      {showIcon && <ArrowRight className="w-6 h-6 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-31" />}
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-32" />
    </motion.button>;
}